import axios from "axios"
import { getBasePath } from "../Utils"

const login = async (logObject) => {
  
  console.log(`${getBasePath()}/v1/login`)
  const response = await axios.post(`${getBasePath()}/v1/login`, logObject)
    if (!response.code === 200)
        throw new Error('Response is NOT ok')
    return response.data
}

export default login;